import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const Wrapper = Styled.div`
  display: flex
`;

const Column = Styled.div`
  flex: 1;
  padding: 32px 30px;

  & + div {
    padding-left: 0;
  }
`;

/**
 * @oaram {string} className
 */
const StyledNekoWrapper = props => {
  return (
    <Wrapper>
      { props.children }
    </Wrapper>
  );
};

const StyledNekoColumn = props => {
  return (
    <Column>{ props.children }</Column>
  );
}

const NekoWrapper = (props) => {
  return (<StyledNekoWrapper {...props} />);
}

const NekoColumn = (props) => {
  return (<StyledNekoColumn {...props} />);
}

NekoWrapper.propTypes = {
};
NekoWrapper.defaultProps = {
};

NekoColumn.propTypes = {
};
NekoColumn.defaultProps = {
};

export { NekoWrapper, NekoColumn };
